import {
  REQUEST_RECIEVE_POPUP_NOTIFICATION,
  RESPONSE_RECIEVE_POPUP_NOTIFICATION,
  REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION,
  RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
} from "../actions/signalRActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  dataRecievePopupNotification: queriesStates.NOT_REQUESTED,
  popupNotifications: [],
  error: null,
};

const popupNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RECIEVE_POPUP_NOTIFICATION: {
      return Object.assign({}, state, {
        dataRecievePopupNotification: queriesStates.REQUEST,
      });
    }

    case REQUEST_STOP_RECIEVE_POPUP_NOTIFICATION: {
      return Object.assign({}, state, {
        dataRecievePopupNotification: queriesStates.NOT_REQUESTED,
      });
    }

    case RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataRecievePopupNotification: queriesStates.NOT_REQUESTED,
      });
    }
    default:
      return state;
  }
};

export default popupNotificationsReducer;
